import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';
function subscribe(callback: () => void) {
  const media = window.matchMedia(QUERY); media.addEventListener('change', callback);
  return () => media.removeEventListener('change', callback);
}
export const prefersReducedMotion = () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches;
/** Live `prefers-reduced-motion`. Motion code must keep every meaning available when this is true. */
export function useReducedMotion() { return useSyncExternalStore(subscribe, prefersReducedMotion, () => false); }

/** Coarse device tier for WebGL budgets. Never used to hide content — only to lower cost. */
export type DeviceTier = 'high' | 'mobile' | 'low';
export function deviceTier(): DeviceTier {
  if (typeof window === 'undefined') return 'mobile';
  const narrow = window.matchMedia('(max-width: 767px)').matches;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  const cores = navigator.hardwareConcurrency ?? 4;
  if ((memory !== undefined && memory <= 2) || cores <= 2) return 'low';
  return narrow || coarse ? 'mobile' : 'high';
}

/** True when a WebGL context can be created at all (cheap probe, released immediately). */
export function webglAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2') ?? canvas.getContext('webgl');
    if (!gl) return false;
    (gl as WebGLRenderingContext).getExtension('WEBGL_lose_context')?.loseContext();
    return true;
  } catch { return false; }
}
